import React from 'react';

const ForbiddenView = () => (
    <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-5">
            <i className="fa-solid fa-shield-halved text-red-400 text-2xl" />
        </div>
        <h2 className="text-lg font-bold text-gray-700 mb-2">접근 권한이 없습니다</h2>
        <p className="text-sm text-gray-400">
            이 기능을 사용할 권한이 없습니다.
            <br />관리자에게 문의하세요.
        </p>
    </div>
);

export default ForbiddenView;
